import { createContext } from "react";

export const FlyoutPlanContext = createContext( {
  plan: {},
  allPlans: [],
  activeDay: null,
  selectedPlaneId: null,
  ctxPlanAddLeg: () => {},
  ctxPlanModifyLeg: () => {},
  ctxPlanDeleteLeg: () => {},
  ctxPlanSwitchDay: () => {},
  ctxPlanUnregister: () => {}
});